module.exports = __webpack_public_path__ + "img/icon_resetnext.5cffc813.png";